import Image from 'next/image'
import Link from 'next/link'
import React from 'react'

export default function ExploreAsco() {
    return (
        <div>
            <div className='my-4 border p-4 rounded-md bg-gray-100 dark:bg-gray-800'>
                <h3 className='text-md font-semibold mb-2 text-center'>ESMO Conference 2024</h3>
                <Image src="https://assets.delveinsight.com/events/1724210100933-esmo-2024.png" width={2000} height={2000} alt="ASCO 2024" />
                <p className='text-sm'>
                    Live Coverage of ESMO 2024 Visit Now for Real-Time Insights and Analytical, Impactful Updates!
                </p>
                <button className='bg-[#1b5df3] w-full text-sm font-semibold text-white px-6 py-2 rounded'>
                    <Link href={process.env.APP_URL + "/esmo-conference-2024"}>Catch the Glimpse here</Link>
                </button>
            </div>
        </div>
    )
}
